import { isEmpty } from "lodash";
import { IFormValues } from "src/Pages/Company/Absences/AbsencesConfiguration";

interface FeatureConfigurationResponse {
  featuresConfigurations: {
    [key: string]: {
      wholeCompany: boolean;
    };
  };
}

export const transformFeatureConfigToFormValues = (
  featureConfigurationData: FeatureConfigurationResponse | undefined
): IFormValues => {
  if (isEmpty(featureConfigurationData)) {
    return {};
  }

  const { featuresConfigurations } = featureConfigurationData;

  return Object.entries(featuresConfigurations).reduce((acc, [key, value]) => {
    (acc as any)[key] = value.wholeCompany;
    return acc;
  }, {} as IFormValues);
};

export const parseDataToBackend = (formData: IFormValues) => {
  const featuresConfigurations = Object.entries(formData).reduce(
    (acc, [key, value]) => {
      acc[key] = {
        wholeCompany: value,
      };
      return acc;
    },
    {} as { [key: string]: { wholeCompany: boolean } }
  );

  return {
    featuresConfigurations,
  };
};
